<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="handleSave"
        class="rkm-modal"
        extra-large
        ref="RkmModal"
        title="Procedimento"
    >
        <Form
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
            style="margin-top: -1rem; margin-bottom: -1rem;"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        model: null,
    }),
    methods: {
        open(item) {
            if (item) {
                this.model = {
                    id: item.id,
                    lotacao: {
                        ocupacao: {
                            id: item.lotacao.ocupacao.id,
                            codigo: item.lotacao.ocupacao.codigo,
                            nome: item.lotacao.ocupacao.nome,
                        },
                        profissional: {
                            nome: item.lotacao.profissional.nome,
                        },
                    },
                    procedimento: item.procedimento,
                    cidPrincipal: item.cidPrincipal,
                    quantidade: item.quantidade,
                }
            } else {
                this.model = {
                    id: null,
                    lotacao: {
                        ocupacao: {
                            id: this.data.form.lotacao.ocupacao.id,
                            codigo: this.data.form.lotacao.ocupacao.codigo,
                            nome: this.data.form.lotacao.ocupacao.nome,
                        },
                        profissional: {
                            nome: this.data.form.lotacao.profissional.nome,
                        },
                    },
                    procedimento: null,
                    cidPrincipal: null,
                    quantidade: 1,
                }
            }

            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.handleExit()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>